export default __webpack_public_path__ + "static/media/002-fingerprint.27748bf4.svg";